import React from 'react';
import { useTranslation } from 'react-i18next';
import { HeroBackground, PageHeader } from '../components';

export const AboutPage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div>
      {/* Hero header cropped to 1/3 */}
      <HeroBackground size='third' />

      {/* Page Title */}
      <PageHeader title={t('nav.about')} subtitle={t('subtitles.about')} />

      <div className='max-w-4xl mx-auto px-5 py-4'>

        <div className='prose prose-lg max-w-none'>
          <div className='bg-church-light rounded-lg p-5 mb-4'>
            <h2 className='text-church-brown text-2xl mb-3 font-medium'>
              {t('about.object_title')}
            </h2>
            {t('about.object_breton') && (
              <p className='text-gray-700 leading-relaxed mb-3 italic'>
                {t('about.object_breton')}
              </p>
            )}
            {t('about.object_text') && (
              <p className='text-gray-700 leading-relaxed'>
                {t('about.object_text')}
              </p>
            )}
          </div>

          <div className='grid md:grid-cols-2 gap-4'>
            <div className='bg-white border border-gray-200 rounded-lg p-5'>
              <h3 className='text-church-brown text-xl mb-3 font-medium'>
                {t('about.mission_title')}
              </h3>
              <p className='text-gray-600'>
                {t('about.mission_text')}
              </p>
            </div>

            <div className='bg-white border border-gray-200 rounded-lg p-5'>
              <h3 className='text-church-brown text-xl mb-3 font-medium'>
                {t('about.values_title')}
              </h3>
              <ul className='text-gray-600 space-y-2'>
                {(t('about.values', { returnObjects: true }) as string[]).map(
                  (value, index) => (
                    <li key={index}>• {value}</li>
                  )
                )}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
